import React, { useEffect, useState } from 'react';
import { fmtFechaHora } from '../../../fct/react';
import { leerEstadoIntakeWeb, type EstadoIntakeWeb } from '../../../api/altasCasosApi';

/** Cada cuánto se vuelve a leer el estado mientras la pantalla está abierta (la tarea pasa cada pocos minutos). */
export const REFRESCO_MS = 60_000;

/** El texto de la línea a partir del estado de la tarea. */
export function textoIntakeWeb(estado: EstadoIntakeWeb): string {
  if (!estado.habilitada) return 'Altas de la web: tarea apagada';

  const partes = ['Altas de la web'];
  partes.push(estado.ultimaPasada ? `última pasada ${fmtFechaHora(estado.ultimaPasada)}` : 'sin pasadas todavía');
  if (estado.pendientes != null) partes.push(`${estado.pendientes} pendientes`);
  if (estado.fallidasUltimaPasada) partes.push(`${estado.fallidasUltimaPasada} con error (avisado a Sistemas)`);
  if (estado.errorUltimaPasada) partes.push(`la última pasada no terminó: ${estado.errorUltimaPasada}`);
  if (estado.soloCuentasPrueba) partes.push('solo cuentas de prueba');
  return partes.join(' · ');
}

/**
 * La línea de estado del intake web en la cabecera de «Altas de clientes» (#291, criterio 7): la hora de la última pasada y
 * las altas que siguen marcadas en la web. Si no se puede leer, no muestra nada: no es lo principal de la pantalla.
 */
const EstadoIntakeWebLinea: React.FC = () => {
  const [estado, setEstado] = useState<EstadoIntakeWeb | null>(null);

  useEffect(() => {
    let vivo = true;
    const leer = () => {
      leerEstadoIntakeWeb()
        .then((e) => { if (vivo) setEstado(e); })
        .catch(() => { if (vivo) setEstado(null); });
    };
    leer();
    const temporizador = window.setInterval(leer, REFRESCO_MS);
    return () => {
      vivo = false;
      window.clearInterval(temporizador);
    };
  }, []);

  return estado ? <span data-testid="estado-intake-web">{textoIntakeWeb(estado)}</span> : null;
};

export default EstadoIntakeWebLinea;
